import Collection from '@/components/Collection'
import access from '../access'

const domainNs = "urn:ietf:params:xml:ns:domain-1.0";

export default {

  'message.collection': {
    path: '/admin/messages',
    name: 'message.collection',
    component:  Object.assign({}, Collection), // https://stackoverflow.com/a/41425312
    props: {
      handler: "listMessages",
      entity: "messagequeue",
      cols: [
        { label: "Registrar", field: "registrar" },
        { label: "Message", field: "msg" },
        { label: "Date", field: "queued_at", sort: "queued_at", date: "date" },
        { label: "Data", html: (row) => {
            // we need to wrap escaped html with real html so we have to do a bit advanced processing here
            let div = document.createElement('div');
            div.innerText = row.response_data.replace(/></g, ">\n  <").replace(/\s\s<\//g, "</");
            return '<pre>' + div.innerHTML + '</pre>';
          }
        },
      ]
    },
    meta: {
      access: access.chain(access.admin, access.service(domainNs)),
      title: "Message list",
      side_menu: { label: "Message queue",  icon: "stack" },
    },
  },

}



// WEBPACK FOOTER //
// ./src/routes/modules/message.js